import pahoMqtt from "@/libs/paho-mqtt";
import { mqttConfig } from '../config/mqtt.config.js'

import { EventEmitter } from '../../EventEmitter.js'

export default class Mqtt extends EventEmitter {
    topics = []
    timeout = 10
    timeoutNum = null;
    reconnectCount = 10;
    constructor() {
        super()
        this.callbackObject = []
        this.MqttSate = false;
        this.Client = new pahoMqtt.Client(mqttConfig.hostname, Math.random().toString(16).substring(2));

        this.Client.onConnectionLost = this.onConnectionLostS.bind(this)
        this.Client.onMessageArrived = this.onMessageArrivedS.bind(this)
        this.Client.onMessageDelivered = this.onMessageDeliveredS.bind(this);

        this.Client.trace = (errorCode)=>{
            let msg = errorCode.message;
            if(msg.indexOf("Client._disconnected")>-1){
                // this.MqttSate = false;
                this.emit('lost', errorCode)
            }
        }
        this.connect();
     
    }
    connect() {
        let that = this;
        this.Client.connect({
            timeout: 40,
            keepAliveInterval: 1800,
            cleanSession: mqttConfig.clean,
            useSSL: false,
            invocationContext: {},
            userName: mqttConfig.username,
            password: mqttConfig.password,
            onSuccess: that.onConnect.bind(this),
            onFailure: (err) => {
                console.warn("Mqtt connection fail", err)
                that.MqttSate = false;
                if (!that.MqttSate) {
                    setTimeout(() => {
                        that.connect();
                    }, 3000)
                }
            },

            reconnect: true,
        })
    }

    msgFormat(msgObj) {
        return JSON.stringify(msgObj) + '\r\n'
    }
    onConnect(res) {
        this.MqttSate = true
        this.emit('connect', res)
    }
    onConnectionLostS(res) {
        this.MqttSate = false
        console.warn("失去连接将自动重新连接", res);

        if (this.reconnectCount > 0) {
            this.reconnectCount--;
        } else {
            this.emit('lost', res)
        }

    }
    packages = {}
    onMessageArrivedS(res) {
        this.timeoutNum && clearTimeout(this.timeoutNum)
        this.timeoutNum = null;
        if (res.payloadBytes) {
            res.data = this.Uint8ArrayToString(res.payloadBytes)
        }

        if (!this.packages[res.topic]) {
            this.packages[res.topic] = []
        }

        let totalpages = res.data.totalpage;
        let pagenumber = res.data.pagenum;

        // 无需分包
        if (!totalpages) {
            this.callbackObject.forEach((item) => {
                if (item.topic === res.topic) {
                    item.callback.forEach(func => {
                        func(res.data)
                    })
                }
            })
            return;
        } else {
            this.packages[res.topic][pagenumber - 1] = res.data.data;
        }
        try {
            // 分包处理
            if (totalpages && this.packages[res.topic].length >= totalpages) {
                this.callbackObject.forEach((item) => {
                    if (item.topic === res.topic) {
                        let data = this.packages[res.topic].reduce((total, currentTarget) => {
                            return { ...total, ...currentTarget }
                        })
                        item.callback.forEach(func => {
                            func({
                                "action": res.data.action, "uuid": res.data.uuid, "data": data
                            })
                        })
                        this.packages[res.topic] = []
                    }
                })
            }
        } catch (error) {
            console.log(error)
        }


    }
    onMessageDeliveredS(res) {
        // console.log("Mqtt Message passing detected", res);
    }
    publishApi(obj) {
        if (!this.MqttSate) {
            console.warn("在三秒未连接后自动重新发布");
            setTimeout(() => {
                this.publishApi(obj)
            }, 3000)
            return
        }
        if (obj.payload) {
            obj.payload = JSON.stringify(obj.payload)
        } else {
            obj.payload = JSON.stringify({
                id: 1,
                version: "1.0",
                method: "thing.sub.list",
                params: {}
            })
        }
        this.Client.publish(obj.topic, obj.payload, 0, false)
    }
    send(topic, msg) {
        const message = new pahoMqtt.Message(this.msgFormat(msg))
      
        message.destinationName = topic
        try {
            this.Client.send(message)
        } catch (error) {
            this.MqttSate = false;
        }
        this.timeoutNum = setTimeout(() => {
            if (!this.Client.isConnected()) {
                this.connect()
            }

        }, this.timeout * 1000)
    }
    //   监测是否已存在订阅主题
    checkedTopic(topic) {
        // 存在历史订阅主题则删除
        for (let i = 0, len = this.callbackObject.length; i < len; i++) {
            if (this.callbackObject[i].topic === topic) {
                return true;
            }
        }
        return false;
    }
    subscriptionApi(obj, callback) {
        if (!this.MqttSate) {
            console.warn("断开链接将在3秒后重新尝试订阅");
            setTimeout(() => {
                this.subscriptionApi(obj, callback)
            }, 3000)
            return
        }

        if (!this.checkedTopic(obj.topic)) {
            this.callbackObject.push({
                topic: obj.topic,
                callback: [callback]
            })
        } else {
            this.callbackObject.forEach(callbackItem => {
                if (callbackItem.topic == obj.topic) {
                    callbackItem.callback.push(callback)
                }
            })
        }
        this.Client.subscribe(obj.topic, {
            qos: 0,
            invocationContext: {},
            onSuccess: (res) => {
                this.emit('subscribe.success', res)

            },
            onFailure: (err) => {
                this.callbackObject.forEach((item, index) => {
                    if (item.topic === obj.topic) {
                        this.callbackObject.splice(index, 1)
                    }
                })
                console.warn("subscribe failure:", err);
            }
        })

    }
    unsubscribe(obj) {
        if (!this.MqttSate) {
            console.warn("在三秒未连接后自动重新取消订阅");
            setTimeout(() => {
                this.unsubscribe(obj)
            }, 3000)
            return
        }
        this.Client.unsubscribe(obj.topic, {
            invocationContext: {},
            onSuccess: function (res) {
                console.log("Subscribe close succeed:", res);
            },
            onFailure: function (err) {
                console.warn("Subscribe close failure:", err);
            }
        })
    }
    Uint8ArrayToString(array) {
        let out, i, len, c;
        let char2, char3;

        out = "";
        len = array.length;
        i = 0;
        while (i < len) {
            c = array[i++];
            switch (c >> 4) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    // 0xxxxxxx
                    out += String.fromCharCode(c);
                    break;
                case 12:
                case 13:
                    // 110x xxxx   10xx xxxx
                    char2 = array[i++];
                    out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
                    break;
                case 14:
                    // 1110 xxxx  10xx xxxx  10xx xxxx
                    char2 = array[i++];
                    char3 = array[i++];
                    out += String.fromCharCode(((c & 0x0F) << 12) |
                        ((char2 & 0x3F) << 6) |
                        ((char3 & 0x3F) << 0));
                    break;
            }
        }
        return JSON.parse(out);
    }
}